import React, { useState } from 'react';
import { Calendar, Star, ChevronLeft, ChevronRight, Heart } from '../icons';

// Nepali Bikram Sambat months
const BS_MONTHS = [
  'बैशाख', 'जेठ', 'असार', 'श्रावण', 'भदौ', 'असोज',
  'कार्तिक', 'मंसिर', 'पौष', 'माघ', 'फागुन', 'चैत'
];

const BS_MONTHS_EN = [
  'Baisakh', 'Jestha', 'Asar', 'Shrawan', 'Bhadra', 'Ashoj',
  'Kartik', 'Mangsir', 'Poush', 'Magh', 'Falgun', 'Chaitra'
];

// Days of week
const WEEKDAYS_NE = ['आइत', 'सोम', 'मंगल', 'बुध', 'बिहि', 'शुक्र', 'शनि'];
const WEEKDAYS_EN = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

// Days in each month for BS 2082
const DAYS_IN_MONTH_2082 = [31, 31, 32, 31, 31, 31, 30, 29, 30, 29, 30, 30];
const DAYS_IN_MONTH_2083 = [31, 32, 31, 32, 31, 30, 30, 30, 29, 29, 30, 31];

// First day of week (0=Sun) for Baisakh 1, 2082 BS = April 14, 2025 (Monday=1)
const FIRST_DOW_2082 = 1; // Monday
// First day of week for Baisakh 1, 2083 BS = April 14, 2026 (Tuesday=2)
const FIRST_DOW_2083 = 2; // Tuesday

// Auspicious wedding dates (lagan/saait) for 2082 BS
// Format: { month (0-indexed), day, adDate, nakshatra, note }
const LAGAN_DATES_2082 = [
  { month: 0, day: 2, adDate: 'Apr 15, 2025', nakshatra: 'रोहिणी', note: 'Vivah Muhurat' },
  { month: 0, day: 10, adDate: 'Apr 23, 2025', nakshatra: 'मघा', note: 'Shubh Lagan' },
  { month: 0, day: 17, adDate: 'Apr 30, 2025', nakshatra: 'उत्तराषाढा', note: 'Vivah Muhurat' },
  { month: 0, day: 22, adDate: 'May 5, 2025', nakshatra: 'रेवती', note: 'Shubh Lagan' },
  { month: 0, day: 28, adDate: 'May 11, 2025', nakshatra: 'मृगशिरा', note: 'Vivah Muhurat' },
  { month: 1, day: 5, adDate: 'May 18, 2025', nakshatra: 'उत्तराफाल्गुनी', note: 'Shubh Lagan' },
  { month: 1, day: 12, adDate: 'May 25, 2025', nakshatra: 'अनुराधा', note: 'Vivah Muhurat' },
  { month: 1, day: 18, adDate: 'May 31, 2025', nakshatra: 'उत्तराषाढा', note: 'Shubh Lagan' },
  { month: 1, day: 25, adDate: 'Jun 7, 2025', nakshatra: 'रेवती', note: 'Vivah Muhurat' },
  { month: 2, day: 3, adDate: 'Jun 16, 2025', nakshatra: 'रोहिणी', note: 'Shubh Lagan' },
  { month: 2, day: 14, adDate: 'Jun 27, 2025', nakshatra: 'मघा', note: 'Vivah Muhurat' },
  { month: 2, day: 21, adDate: 'Jul 4, 2025', nakshatra: 'स्वाती', note: 'Shubh Lagan' },
  { month: 6, day: 7, adDate: 'Oct 22, 2025', nakshatra: 'रोहिणी', note: 'Vivah Muhurat (Post-Chaumasa)' },
  { month: 6, day: 15, adDate: 'Oct 30, 2025', nakshatra: 'उत्तराफाल्गुनी', note: 'Shubh Lagan' },
  { month: 6, day: 22, adDate: 'Nov 6, 2025', nakshatra: 'मूल', note: 'Vivah Muhurat' },
  { month: 7, day: 5, adDate: 'Nov 20, 2025', nakshatra: 'रेवती', note: 'Shubh Lagan' },
  { month: 7, day: 12, adDate: 'Nov 27, 2025', nakshatra: 'मृगशिरा', note: 'Vivah Muhurat' },
  { month: 7, day: 19, adDate: 'Dec 4, 2025', nakshatra: 'मघा', note: 'Shubh Lagan' },
  { month: 7, day: 26, adDate: 'Dec 11, 2025', nakshatra: 'अनुराधा', note: 'Vivah Muhurat' },
  { month: 8, day: 4, adDate: 'Dec 19, 2025', nakshatra: 'उत्तराषाढा', note: 'Shubh Lagan' },
  { month: 8, day: 12, adDate: 'Dec 27, 2025', nakshatra: 'रेवती', note: 'Vivah Muhurat' },
  { month: 8, day: 20, adDate: 'Jan 4, 2026', nakshatra: 'रोहिणी', note: 'Shubh Lagan' },
  { month: 8, day: 27, adDate: 'Jan 11, 2026', nakshatra: 'मघा', note: 'Vivah Muhurat' },
  { month: 9, day: 5, adDate: 'Jan 18, 2026', nakshatra: 'स्वाती', note: 'Shubh Lagan' },
  { month: 9, day: 12, adDate: 'Jan 25, 2026', nakshatra: 'मूल', note: 'Vivah Muhurat' },
  { month: 9, day: 19, adDate: 'Feb 1, 2026', nakshatra: 'उत्तराषाढा', note: 'Shubh Lagan' },
  { month: 9, day: 25, adDate: 'Feb 7, 2026', nakshatra: 'रेवती', note: 'Vivah Muhurat' },
  { month: 10, day: 3, adDate: 'Feb 14, 2026', nakshatra: 'रोहिणी', note: 'Shubh Lagan' },
  { month: 10, day: 10, adDate: 'Feb 21, 2026', nakshatra: 'उत्तराफाल्गुनी', note: 'Vivah Muhurat' },
  { month: 10, day: 18, adDate: 'Mar 1, 2026', nakshatra: 'अनुराधा', note: 'Shubh Lagan' },
  { month: 10, day: 25, adDate: 'Mar 8, 2026', nakshatra: 'उत्तराषाढा', note: 'Vivah Muhurat' },
  { month: 11, day: 3, adDate: 'Mar 16, 2026', nakshatra: 'रेवती', note: 'Shubh Lagan' },
  { month: 11, day: 10, adDate: 'Mar 23, 2026', nakshatra: 'मृगशिरा', note: 'Vivah Muhurat' },
  { month: 11, day: 18, adDate: 'Mar 31, 2026', nakshatra: 'मघा', note: 'Shubh Lagan' },
  { month: 11, day: 25, adDate: 'Apr 7, 2026', nakshatra: 'स्वाती', note: 'Vivah Muhurat' },
];

// Auspicious wedding dates (lagan/saait) for 2083 BS — शुभ विवाह लगन २०८३
// Baisakh 1 = Apr 14, 2026 (Tue)
const LAGAN_DATES_2083 = [
  // Baisakh (Apr–May 2026)
  { month: 0, day: 7,  adDate: 'Mon, Apr 20, 2026', nakshatra: 'रोहिणी',         note: 'Vivah Muhurat' },
  { month: 0, day: 8,  adDate: 'Tue, Apr 21, 2026', nakshatra: 'मृगशिरा',        note: 'Shubh Lagan' },
  { month: 0, day: 22, adDate: 'Tue, May 5, 2026',  nakshatra: 'उत्तराफाल्गुनी', note: 'Vivah Muhurat' },
  { month: 0, day: 23, adDate: 'Wed, May 6, 2026',  nakshatra: 'हस्त',            note: 'Shubh Lagan' },
  { month: 0, day: 24, adDate: 'Thu, May 7, 2026',  nakshatra: 'स्वाती',          note: 'Vivah Muhurat' },
  { month: 0, day: 25, adDate: 'Fri, May 8, 2026',  nakshatra: 'अनुराधा',         note: 'Shubh Lagan' },
  { month: 0, day: 30, adDate: 'Wed, May 13, 2026', nakshatra: 'उत्तराषाढा',     note: 'Vivah Muhurat' },
  { month: 0, day: 31, adDate: 'Thu, May 14, 2026', nakshatra: 'श्रवण',           note: 'Shubh Lagan' },

  // Asar / Ashar (Jun–Jul 2026)
  { month: 2, day: 9,  adDate: 'Wed, Jun 24, 2026', nakshatra: 'रोहिणी',         note: 'Vivah Muhurat' },
  { month: 2, day: 13, adDate: 'Sun, Jun 28, 2026', nakshatra: 'उत्तराफाल्गुनी', note: 'Shubh Lagan' },
  { month: 2, day: 14, adDate: 'Mon, Jun 29, 2026', nakshatra: 'हस्त',            note: 'Vivah Muhurat' },
  { month: 2, day: 15, adDate: 'Tue, Jun 30, 2026', nakshatra: 'अनुराधा',         note: 'Shubh Lagan' },
  { month: 2, day: 17, adDate: 'Thu, Jul 2, 2026',  nakshatra: 'उत्तराषाढा',     note: 'Vivah Muhurat' },
  { month: 2, day: 18, adDate: 'Fri, Jul 3, 2026',  nakshatra: 'श्रवण',           note: 'Shubh Lagan' },
  { month: 2, day: 23, adDate: 'Wed, Jul 8, 2026',  nakshatra: 'रेवती',           note: 'Vivah Muhurat' },

  // Mangsir (Nov–Dec 2026)
  { month: 7, day: 9,  adDate: 'Wed, Nov 25, 2026', nakshatra: 'रोहिणी',         note: 'Vivah Muhurat' },
  { month: 7, day: 10, adDate: 'Thu, Nov 26, 2026', nakshatra: 'मृगशिरा',        note: 'Shubh Lagan' },
  { month: 7, day: 16, adDate: 'Wed, Dec 2, 2026',  nakshatra: 'उत्तराफाल्गुनी', note: 'Vivah Muhurat' },
  { month: 7, day: 17, adDate: 'Thu, Dec 3, 2026',  nakshatra: 'हस्त',            note: 'Shubh Lagan' },
  { month: 7, day: 19, adDate: 'Sat, Dec 5, 2026',  nakshatra: 'अनुराधा',         note: 'Vivah Muhurat' },
  { month: 7, day: 24, adDate: 'Thu, Dec 10, 2026', nakshatra: 'उत्तराषाढा',     note: 'Shubh Lagan' },
  { month: 7, day: 25, adDate: 'Fri, Dec 11, 2026', nakshatra: 'श्रवण',           note: 'Vivah Muhurat' },
  { month: 7, day: 26, adDate: 'Sat, Dec 12, 2026', nakshatra: 'रेवती',           note: 'Shubh Lagan' },

  // Magh (Jan–Feb 2027)
  { month: 9, day: 4,  adDate: 'Mon, Jan 18, 2027', nakshatra: 'रोहिणी',         note: 'Vivah Muhurat' },
  { month: 9, day: 12, adDate: 'Tue, Jan 26, 2027', nakshatra: 'उत्तराफाल्गुनी', note: 'Shubh Lagan' },
  { month: 9, day: 15, adDate: 'Fri, Jan 29, 2027', nakshatra: 'हस्त',            note: 'Vivah Muhurat' },
  { month: 9, day: 19, adDate: 'Tue, Feb 2, 2027',  nakshatra: 'अनुराधा',         note: 'Shubh Lagan' },
  { month: 9, day: 20, adDate: 'Wed, Feb 3, 2027',  nakshatra: 'उत्तराषाढा',     note: 'Vivah Muhurat' },
  { month: 9, day: 27, adDate: 'Wed, Feb 10, 2027', nakshatra: 'रेवती',           note: 'Shubh Lagan' },

  // Falgun (Feb–Mar 2027)
  { month: 10, day: 3,  adDate: 'Mon, Feb 15, 2027', nakshatra: 'रोहिणी',         note: 'Vivah Muhurat' },
  { month: 10, day: 4,  adDate: 'Tue, Feb 16, 2027', nakshatra: 'मृगशिरा',        note: 'Shubh Lagan' },
  { month: 10, day: 11, adDate: 'Tue, Feb 23, 2027', nakshatra: 'उत्तराफाल्गुनी', note: 'Vivah Muhurat' },
  { month: 10, day: 12, adDate: 'Wed, Feb 24, 2027', nakshatra: 'हस्त',            note: 'Shubh Lagan' },
  { month: 10, day: 15, adDate: 'Sat, Feb 27, 2027', nakshatra: 'स्वाती',          note: 'Vivah Muhurat' },
  { month: 10, day: 16, adDate: 'Sun, Feb 28, 2027', nakshatra: 'अनुराधा',         note: 'Shubh Lagan' },
  { month: 10, day: 17, adDate: 'Mon, Mar 1, 2027',  nakshatra: 'उत्तराषाढा',     note: 'Vivah Muhurat' },
  { month: 10, day: 18, adDate: 'Tue, Mar 2, 2027',  nakshatra: 'श्रवण',           note: 'Shubh Lagan' },
  { month: 10, day: 20, adDate: 'Thu, Mar 4, 2027',  nakshatra: 'रेवती',           note: 'Vivah Muhurat' },
  { month: 10, day: 25, adDate: 'Tue, Mar 9, 2027',  nakshatra: 'रोहिणी',         note: 'Shubh Lagan' },
  { month: 10, day: 26, adDate: 'Wed, Mar 10, 2027', nakshatra: 'मृगशिरा',        note: 'Vivah Muhurat' },
  { month: 10, day: 30, adDate: 'Sun, Mar 14, 2027', nakshatra: 'उत्तराफाल्गुनी', note: 'Shubh Lagan' },
];

// BS year → start date of Baisakh 1 in AD
const BS_YEAR_STARTS = {
  2082: new Date(2025, 3, 14), // April 14, 2025
  2083: new Date(2026, 3, 14), // April 14, 2026
};

const AD_MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

// Returns the first day (JS Date) of a given BS year/month
function bsMonthStart(bsYear, bsMonth) {
  const yearStart = BS_YEAR_STARTS[bsYear];
  if (!yearStart) return new Date();
  const daysInMonths = bsYear === 2082 ? DAYS_IN_MONTH_2082 : DAYS_IN_MONTH_2083;
  let offset = 0;
  for (let i = 0; i < bsMonth; i++) offset += daysInMonths[i];
  const d = new Date(yearStart);
  d.setDate(d.getDate() + offset);
  return d;
}

function getFirstDow(year, month) {
  const daysInMonths = year === 2082 ? DAYS_IN_MONTH_2082 : DAYS_IN_MONTH_2083;
  const firstDow = year === 2082 ? FIRST_DOW_2082 : FIRST_DOW_2083;
  let totalDays = 0;
  for (let i = 0; i < month; i++) {
    totalDays += daysInMonths[i];
  }
  return (firstDow + totalDays) % 7;
}

function LaganCalendar({ lang = 'en', compact = false }) {
  const [bsYear, setBsYear] = useState(2083);
  const [bsMonth, setBsMonth] = useState(() => {
    // Default to current approximate BS month
    const now = new Date();
    const m = now.getMonth(); // 0-based JS month
    // Rough mapping AD month → BS month: Apr=Baisakh(0), May=Jestha(1), Jun=Asar(2)...
    const mapping = [9, 10, 11, 0, 1, 2, 3, 4, 5, 6, 7, 8];
    return mapping[m];
  });

  const daysInMonth = bsYear === 2082 ? DAYS_IN_MONTH_2082 : DAYS_IN_MONTH_2083;
  const laganDates = bsYear === 2082 ? LAGAN_DATES_2082 : LAGAN_DATES_2083;
  const monthDays = daysInMonth[bsMonth];
  const firstDow = getFirstDow(bsYear, bsMonth);

  const lagansThisMonth = laganDates.filter(d => d.month === bsMonth);
  const laganDaySet = new Set(lagansThisMonth.map(d => d.day));

  const weekdays = lang === 'ne' ? WEEKDAYS_NE : WEEKDAYS_EN;
  const monthName = lang === 'ne' ? BS_MONTHS[bsMonth] : BS_MONTHS_EN[bsMonth];

  // Gregorian calendar data
  const adStart = bsMonthStart(bsYear, bsMonth);
  const adEnd = new Date(adStart);
  adEnd.setDate(adEnd.getDate() + monthDays - 1);
  const adMonthTitle = adStart.getMonth() === adEnd.getMonth()
    ? `${AD_MONTH_NAMES[adStart.getMonth()]} ${adStart.getFullYear()}`
    : `${AD_MONTH_NAMES[adStart.getMonth()]}–${AD_MONTH_NAMES[adEnd.getMonth()]} ${adStart.getFullYear()}`;

  const prevMonth = () => {
    if (bsMonth === 0) {
      if (bsYear > 2082) { setBsYear(bsYear - 1); setBsMonth(11); }
    } else {
      setBsMonth(bsMonth - 1);
    }
  };

  const nextMonth = () => {
    if (bsMonth === 11) {
      if (bsYear < 2083) { setBsYear(bsYear + 1); setBsMonth(0); }
    } else {
      setBsMonth(bsMonth + 1);
    }
  };

  // BS calendar cells (left panel)
  const bsCells = [];
  for (let i = 0; i < firstDow; i++) {
    bsCells.push(<div key={`be-${i}`} className="lagan-cell empty" />);
  }
  for (let d = 1; d <= monthDays; d++) {
    const isLagan = laganDaySet.has(d);
    const laganInfo = lagansThisMonth.find(l => l.day === d);
    bsCells.push(
      <div key={`bs-${d}`} className={`lagan-cell ${isLagan ? 'lagan-day' : ''}`} title={isLagan ? `${laganInfo.nakshatra} — ${laganInfo.adDate}` : ''}>
        <span className="lagan-day-num">{d}</span>
        {isLagan && <Star size={10} className="lagan-star" />}
      </div>
    );
  }

  // Gregorian calendar cells (right panel) — same weekday alignment
  const adCells = [];
  for (let i = 0; i < firstDow; i++) {
    adCells.push(<div key={`ae-${i}`} className="lagan-cell empty" />);
  }
  for (let d = 1; d <= monthDays; d++) {
    const adDate = new Date(adStart);
    adDate.setDate(adDate.getDate() + d - 1);
    const isLagan = laganDaySet.has(d);
    adCells.push(
      <div key={`ad-${d}`} className={`lagan-cell ${isLagan ? 'lagan-day' : ''}`}>
        <span className="lagan-day-num">{adDate.getDate()}</span>
        {isLagan && <Star size={10} className="lagan-star" />}
      </div>
    );
  }

  return (
    <div className={`lagan-calendar lagan-dual ${compact ? 'lagan-compact' : ''}`}>
      {/* Shared navigation header */}
      <div className="lagan-header">
        <button onClick={prevMonth} className="lagan-nav-btn" disabled={bsYear === 2082 && bsMonth === 0}>
          <ChevronLeft size={18} />
        </button>
        <div className="lagan-dual-titles">
          <div className="lagan-month-title">
            <Calendar size={16} />
            <span>{monthName} {bsYear} <small>BS</small></span>
          </div>
          <span className="lagan-dual-arrow">↔</span>
          <div className="lagan-month-title lagan-month-title-en">
            <Calendar size={16} />
            <span>{adMonthTitle} <small>AD</small></span>
          </div>
        </div>
        <button onClick={nextMonth} className="lagan-nav-btn" disabled={bsYear === 2083 && bsMonth === 11}>
          <ChevronRight size={18} />
        </button>
      </div>

      {/* Dual calendar panels */}
      <div className="lagan-dual-panels">
        {/* Left: Nepali BS calendar */}
        <div className="lagan-panel">
          <div className="lagan-panel-label">{lang === 'ne' ? 'नेपाली पात्रो' : 'Nepali (BS)'}</div>
          <div className="lagan-weekdays">
            {weekdays.map(w => <div key={`nw-${w}`} className="lagan-weekday">{w}</div>)}
          </div>
          <div className="lagan-grid">
            {bsCells}
          </div>
        </div>

        <div className="lagan-panel-divider" />

        {/* Right: English Gregorian calendar */}
        <div className="lagan-panel">
          <div className="lagan-panel-label">English (AD)</div>
          <div className="lagan-weekdays">
            {WEEKDAYS_EN.map(w => <div key={`ew-${w}`} className="lagan-weekday">{w}</div>)}
          </div>
          <div className="lagan-grid">
            {adCells}
          </div>
        </div>
      </div>

      {lagansThisMonth.length > 0 && (
        <div className="lagan-dates-list">
          <h4><Heart size={14} /> {lang === 'ne' ? 'शुभ विवाह लगन' : 'Auspicious Wedding Dates'}</h4>
          {lagansThisMonth.map((l, i) => (
            <div key={i} className="lagan-date-item">
              <div className="lagan-date-badge">{l.day}</div>
              <div className="lagan-date-info">
                <span className="lagan-date-main">{monthName} {l.day} BS — {l.adDate}</span>
                <span className="lagan-date-detail">{l.nakshatra} • {l.note}</span>
              </div>
            </div>
          ))}
        </div>
      )}

      {lagansThisMonth.length === 0 && (
        <div className="lagan-empty">
          <p>{lang === 'ne' ? 'यस महिनामा कुनै विवाह लगन छैन' : 'No wedding lagan dates this month'}</p>
          <p className="lagan-empty-sub">{lang === 'ne' ? '(चौमासे अवधि — श्रावण देखि असोज)' : '(Chaumase period — Shrawan to Ashoj)'}</p>
        </div>
      )}
    </div>
  );
}

export default LaganCalendar;
